import { render } from "./QuickHeadings.vue?vue&type=template&id=6469b124"
import script from "./QuickHeadings.vue?vue&type=script&lang=js"
export * from "./QuickHeadings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__